import { FC } from "react";
import CCLogo from "../../assets/img/Logo.svg";

const SuccessEnquiry: FC = () => {
  return (
    <div className="d-flex flex-column gap-20 fw-400 text-black">
      <div className="fs-30">Your enquiry has been submitted</div>
      <div className="fs-16">
        Thank you for your interest. We will get in touch with you once your
        enquiry has been reviewed.
      </div>
    </div>
  );
};

export default SuccessEnquiry;
